


















import { defineComponent } from '@vue/composition-api';

import MailAccount from '@/components/wizard/steps/runtime/configuration/MailAccount.vue';
import Database from '@/components/wizard/steps/runtime/configuration/Database.vue';
import PhpVersion from '@/components/wizard/steps/runtime/configuration/PhpVersion.vue';
import PublicFolderPath from '@/components/wizard/steps/runtime/configuration/PublicFolderPath.vue';

export default defineComponent({
  name: 'SetupRuntimeConfiguration',
  components: {
    PhpVersion,
    Database,
    MailAccount,
    PublicFolderPath,
  },
  setup() {},
});
